import { FC, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from 'components/icon';
import { connect } from 'react-redux';
import { RootState } from 'store/types';
import './sidebar.scss';
import CountBadge from 'components/count-badge';
import { getLodgingRequestsAllCount } from 'store/actions/lodgingRequest';
import { Dispatch } from 'redux';
import { Roles } from 'store/reducers/session/types';
import ShowForRoles from '../show-for-roles';
import { getActiveReservationsCount } from 'store/actions/room';
import { isSidebarRoute } from './sidebarRoutes';

interface StateProps {
  getAllCount: number;
  activeReservationsCount: number;
}

interface DispatchProps {
  getLodgingRequestsAllCount(): Promise<void>;
  getActiveReservationsCount(): Promise<void>;
}

interface AppSidebarProps extends StateProps, DispatchProps { }

const AppSidebar: FC<AppSidebarProps> = ({ getAllCount, activeReservationsCount, getLodgingRequestsAllCount, getActiveReservationsCount }: AppSidebarProps) => {

  useEffect(() => {
    getLodgingRequestsAllCount();
    getActiveReservationsCount();
  }, [getLodgingRequestsAllCount, getActiveReservationsCount]);

  return (
    <div className="app-sidebar">
      <nav className="sidebar-nav">
        <ul>
          <li>
            <NavLink
              title="Dashboard"
              exact to="/"
              isActive={(match, location) => {
                return location.pathname === '/' || location.pathname.includes('occupancy-rate');
              }}
            >
              <Icon name="sidebar/reports" />
            </NavLink>
          </li>
          <li>
            <NavLink title="Guests" to="/app/guests">
              <Icon name="sidebar/guests" />
            </NavLink>
          </li>
          <li>
            <NavLink
              title="Requests"
              to="/app/requests/open"
              isActive={(match, location) => {
                return location.pathname.includes('requests') || location.pathname.includes('booking/');
              }}
            >
              <Icon name="sidebar/requests" />
              <CountBadge count={getAllCount > 99 ? '99+' : getAllCount} />
            </NavLink>
          </li>
          <li>
            <NavLink
              title="Reservations"
              to="/app/reservations/active"
              isActive={(match, location) => {
                return location.pathname.includes('/reservations');
              }}
            >
              <Icon name="sidebar/reservation-new" />
            </NavLink>
          </li>
          <li>
            <NavLink title="Lodgings" to="/app/lodgings">
              <Icon name="sidebar/lodgings" />
            </NavLink>
          </li>
          <li>
            <NavLink
              title="Lodgings & Reservations"
              to="/app/lodgings-and-reservations"
              isActive={(match, location) => {
                return location.pathname.includes('/lodgings-and-reservations');
              }}
              exact={true}
            >
              <Icon name="sidebar/lodgings-and-reservations" />
            </NavLink>
          </li>
          <ShowForRoles roles={[Roles.SuperAdmin]}>
            <li>
              <NavLink
                title="Settings"
                to="/app/users"
                isActive={(match, location) => {
                  return isSidebarRoute(location.pathname);
                }}
              >
                <Icon name="sidebar/settings" />
              </NavLink>
            </li>
          </ShowForRoles>
        </ul>
      </nav>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  getAllCount: state.lodgingRequest.getAllCount.contents,
  activeReservationsCount: state.room.getActiveReservationsCount.contents
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  getLodgingRequestsAllCount: () => dispatch(getLodgingRequestsAllCount()),
  getActiveReservationsCount: () => dispatch(getActiveReservationsCount())
});

export default connect<StateProps, DispatchProps, {}, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(AppSidebar);
